import { BetaSchemaForm, ProFormInstance } from '@ant-design/pro-form';
import { Button, Space, message } from 'antd';
import { FC, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import errorHandler from 'utils/errorHandler';
import { DataItem, SourceviewColumns } from './Sourceview.fields';
import { SourceviewProps, bodyStyle } from './typings';

const data = {
  selectedPlan: 'business',
};

const EditSourceviewForm: FC<SourceviewProps> = ({ modal }) => {
  const { t } = useTranslation('pages', { keyPrefix: 'accounts.edit_sourceview' });
  const modalFormRef = useRef<ProFormInstance>();

  const setAttributes = useCallback(
    (value: DataItem) => modalFormRef?.current?.setFieldsValue(value),
    [modalFormRef],
  );

  useEffect(() => {
    setAttributes(data);
  }, [setAttributes]);

  const closeModal = useCallback(() => {
    modalFormRef.current?.resetFields();
    modal.hide();
  }, [modal]);

  const onFinish = async (formData: DataItem) => {
    try {
      message.success(t('edit_success_text', { company: formData.selectedPlan }));
      closeModal();
    } catch (error) {
      message.error(errorHandler(error));
    }
  };

  return (
    <BetaSchemaForm<DataItem>
      layoutType="ModalForm"
      title={t('edit_modal_title')}
      formRef={modalFormRef}
      columns={SourceviewColumns({
        t,
        defaultPlan: data?.selectedPlan,
      })}
      grid
      open={modal.visible}
      autoFocusFirstInput
      modalProps={{
        destroyOnClose: true,
        maskClosable: false,
        bodyStyle,
        width: '150vh',
        ...modal,
        onCancel: closeModal,
      }}
      submitter={{
        searchConfig: {
          submitText: t('save'),
          resetText: t('cancel'),
        },
        submitButtonProps: {
          shape: 'round',
        },
        resetButtonProps: {
          shape: 'round',
          type: 'primary',
          ghost: true,
        },
        render: (_, defaultDoms) => [
          <Space>
            <Button shape="round" type="link" ghost className="primarycolor">
              {t('remove_plan')}
            </Button>
          </Space>,
          defaultDoms,
        ],
      }}
      submitTimeout={2000}
      onFinish={onFinish}
    />
  );
};

export default EditSourceviewForm;
